import axios from "axios";
import { __constants } from "../../constants";
import { apiResponse } from "../../utils";
import { getUsersByConceirge } from "../Concierge";
import moment from "moment"
import { queryGenerator } from "./common";
const BASE_URL = process.env.REACT_APP_SERVER_URL;


export const getHouseKeepersListing = async (param) => {
    try {
        if (param.conceirgeId) {
            const response = await getUsersByConceirge(`limit=${__constants.listingLimit}${queryGenerator(param)}`, "HouseKeeper", param.conceirgeId)
            return response;
        } else {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/user-management/housekeeper?limit=${__constants.listingLimit}${queryGenerator(param)}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    }
    } catch (err) {
        console.error("Error in getHouseKeepersListing >> ", err.message);
        return err.response
    }
}

export const getHouseKeeperProfileController =  async (id,  month = moment().format("YYYY-MM")) => {
    try {
        const config = {
            method: 'GET',
            url: `${BASE_URL}/v1/admin/user-management/housekeeper/${id}/${month}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        if (response.data.status === 200) { /* Handle logic for API response */
            let frAvailableFor = [],
                frInterestedFor = [],
                experience = [],
                availableFor = [],
                interestedFor = [],
                check;

            response.data.data.preUserDetails.basicDetail.forEach((object) => {  /* format available/interested for */
                if (object.type === "availableForHouseKeeper") frAvailableFor = object.data
                else if (object.type === "interestedForHouseKeeper") frInterestedFor = object.data
            })

            check = response.data.data.houseKeeper.length > 0 && response.data.data.houseKeeper[0].availableFor.length > 0
            frAvailableFor.forEach((outElem) => {  /* Available For */
                if (check && response.data.data.houseKeeper[0].availableFor[0].some((innerElem) => innerElem.name === outElem.name)) {
                    availableFor.push({
                        _id: outElem._id,
                        isMarked: true,
                        name: outElem.name,
                        image :outElem.file
                    })
                } else if (check) {
                    availableFor.push({
                        _id: outElem._id,
                        isMarked: false,
                        name: outElem.name,
                        image :outElem.file
                    })
                }

            })

            check = response.data.data.houseKeeper.length > 0 && response.data.data.houseKeeper[0].interestedFor.length > 0
            frInterestedFor.forEach((outElem) => { /* Interested For */
                if (check && response.data.data.houseKeeper[0].interestedFor[0].some((innerElem) => innerElem.name === outElem.name)) {
                    interestedFor.push({
                        _id: outElem._id,
                        isMarked: true,
                        name: outElem.name,
                        image :outElem.file
                    })
                } else if (check) {
                    interestedFor.push({
                        _id: outElem._id,
                        isMarked: false,
                        name: outElem.name,
                        image :outElem.file
                    })
                }
            })

            check = response.data.data.houseKeeper.length > 0
            response.data.data.preUserDetails.experience.forEach((outElem) => { /* Experience */
                if (check && response.data.data.houseKeeper[0].experience.some((innerElem) => innerElem.from === outElem.from && innerElem.to === outElem.to)) {
                    experience.push({
                        _id: outElem._id,
                        isMarked: true,
                        from: outElem.from,
                        to: outElem.to
                    })
                } else if (check) {
                    experience.push({
                        _id: outElem._id,
                        isMarked: false,
                        from: outElem.from,
                        to: outElem.to
                    })
                }
            })

            return apiResponse({ data: { availableFor, interestedFor, experience, languages: response.data.data.preUserDetails.countryLanguages, userInfo: response.data.data.houseKeeper.length > 0 ? response.data.data.houseKeeper[0] : {} } })
        } else {
            return apiResponse({
                error: response.data.errors,
                status: response.data.status
            })
        }
    } catch (err) {
        return apiResponse({
            error: err.response,
            status: 500,
            message: "Something went wrong"
        })
    }
}
